import templateUrl from './timezoneDiscrepancyComponent.html';

const CLIENT_FLAG = 'dismissedTimezoneDiscrepancyWarning';

class TimezoneDiscrepancyCtrl {
  constructor(Authentication, PersonaCollection, Restangular, $rootScope, $state, $window) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      Restangular,
      $rootScope,
      $state,
      $window,
    });
  }

  $onInit() {
    try {
      // eslint-disable-next-line new-cap
      this.osTimezone = this.$window.Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch {
      // browser does not support it - probably IE ;)
    }
  }

  $doCheck() {
    const shown = this.shown;
    if (this._prevShown !== shown) {
      this.shownBinding = shown;
      this._prevShown = shown;
    }
  }

  get user() {
    return this.Authentication.user;
  }

  get shown() {
    if (this.$rootScope.readonlyMode || !this.osTimezone || !this.user || this.isMyProfileState()) {
      return false;
    }

    if (this.user.timezone !== this.osTimezone) {
      return (
        this.Authentication.user.settings.clientFlags[CLIENT_FLAG] !== this.getDiscrepancyKey()
      );
    }

    return false;
  }

  getDiscrepancyKey() {
    return `${this.user.timezone};${this.osTimezone}`;
  }

  isMyProfileState() {
    return (
      this.$state.is('dashboard.manage.users.profile', { userId: this.user?.id }) ||
      this.$state.is('users.profile', { userId: this.user?.id })
    );
  }

  async fixTimezone() {
    const user = this.Restangular.copy(this.PersonaCollection.me);
    user.timezone = this.osTimezone;
    await user.put({ 'user-fields': 'full' });

    this.user.settings.clientFlags[CLIENT_FLAG] = false;
    this.Authentication.syncSettings();
  }

  dismiss() {
    this.user.settings.clientFlags[CLIENT_FLAG] = this.getDiscrepancyKey();
    this.Authentication.syncSettings();
  }
}

export default {
  templateUrl,
  controllerAs: 'ctrl',
  controller: TimezoneDiscrepancyCtrl,
  bindings: {
    shownBinding: '=isShown',
  },
};
